import React from 'react';
import classNames from 'classnames';
import { Button, Typography } from 'antd';
import { CameraOutlined, EyeInvisibleOutlined } from '@ant-design/icons';
import { useLabelTypes } from 'utils/collection-spot-label-utils';
import { getMediaWithSize } from 'utils/media-utils';
import CollectionSpotTip from './CollectionSpotTip';
import SpotCategory from './SpotCategory';
import { SpotLabel } from './SpotLabel';
import './style.css';

const { Paragraph } = Typography;

/**
 *
 * @param {Object} props
 * @param {CollectionSpot} props.collectionSpot
 * @param {boolean} props.isDimmed
 */
function CollectionSpot({ collectionSpot, isDimmed = false }) {
    const { labelTypes } = useLabelTypes();

    const closestSizedMedia = getMediaWithSize(collectionSpot.featured_photo, 390);

    const labels = collectionSpot.labels
        .map((label) => labelTypes.find(({ id }) => id === label.collection_spot_label_type_id)?.name)
        .filter((x) => x);

    return (
        <div className={classNames('collection-spot', { 'is-dimmed': isDimmed })}>
            <div className='collection-spot-meta'>
                {collectionSpot.ready_for_review && (
                    <div className='collection-spot-review-banner'>Ready for review</div>
                )}
                <div className='collection-spot-labels'>
                    <div className='collection-spot-label'>
                        <SpotCategory spot={collectionSpot.spot} />
                    </div>
                    {labels.map((label) => (
                        <div className='collection-spot-label' key={label}>
                            <SpotLabel name={label} />
                        </div>
                    ))}
                </div>
                <div className='collection-spot-controls'>
                    <Button size='small' icon={<CameraOutlined />} disabled />
                </div>
            </div>
            <div className='collection-spot-content'>
                <div className='collection-spot-image'>
                    {closestSizedMedia && (
                        <img
                            className='collection-spot-image-img'
                            src={closestSizedMedia.path}
                            alt={collectionSpot.name}
                        />
                    )}
                    <div className='collection-spot-image-decorator' />
                </div>
                <div className='collection-spot-title'>
                    <Paragraph
                        ellipsis={{ rows: 1, expandable: false }}
                        className='collection-spot-paragraph collection-spot-title-text'>
                        {collectionSpot.name}
                    </Paragraph>
                </div>
                <CollectionSpotTip collectionSpot={collectionSpot} />
            </div>
            {!collectionSpot.published && (
                <div className='collection-spot__unpublished-overlay'>
                    <EyeInvisibleOutlined style={{ fontSize: 24 }} />
                    <div className='mt-s'>Unpublished spot</div>
                </div>
            )}
        </div>
    );
}

export default CollectionSpot;
